import { Popconfirm } from 'antd';
import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { DefaultTheme, useTheme } from 'styled-components';

import { Icon } from '@/components/Icon';

type Props = {
  isHighlighted: boolean;
  onToggleHighlight: () => void;
  isEditing: boolean;
  isWorking: boolean;
  onDelete: () => void;
};

export const FormHeader: React.FC<Props> = ({
  isHighlighted,
  onToggleHighlight,
  isEditing,
  isWorking,
  onDelete
}) => {
  const { colors } = useTheme();
  const { t } = useTranslation('ChatTranslations');

  return (
    <Flex align="center" gap={8}>
      <Button
        type="link"
        shape="circle"
        icon={
          <Icon
            i={isHighlighted ? 'StarFilled' : 'Star'}
            color={isHighlighted ? (colors.green6 as keyof DefaultTheme['colors']) : undefined}
          />
        }
        onClick={onToggleHighlight}
      />
      {isEditing && (
        <Popconfirm title={t('DELETE_INTERNAL_NOTE_CONFIRM')} onConfirm={onDelete}>
          <Button
            type="link"
            danger
            shape="circle"
            icon={<Icon i="TrashCan" />}
            loading={isWorking}
          />
        </Popconfirm>
      )}
    </Flex>
  );
};
